/* (c) ANNECA s.r.o. (www.anneca.cz) */
import {initPreviewFor} from "../utils/WebPreview.ts";
import {Icon} from "anneca-symbols";

(function($) {
	const defaults = {
		title: 'Reminders',
		editLabel: 'Double-click to edit',
		addListAction: 'Add list',
		addActivityAction: 'Add activity',
		selectorLabel: 'Group',
		orderLabel: 'Order',
		listNamePlaceholder: 'list title',
		okButton: 'OK',
		cancelButton: 'Cancel',
		deleteButton: 'Delete list',
		sortManual: 'manually',
		sortPriority: 'by priority',
		sortDate: 'by date',
		sortType: 'by type',
		sortCustomer: 'by account',
		orderNew: 'new first',
		orderOld: 'old first',
		orderRecent: 'recent first'
	};

	$.fn.tasklist = function(options) {
		// method calling
		if (typeof options == 'string') {
			const args = Array.prototype.slice.call(arguments, 1);
			let res = undefined;
			this.each(function() {
				const tasklist = $.data(this, 'taskList');
				if (tasklist && $.isFunction(tasklist[options])) {
					const r = tasklist[options].apply(tasklist, args);
					if (res === undefined) { res = r; }
					if (options === 'destroy') { $.removeData(this, 'taskList'); }
				}
			});
			if (res !== undefined) {
				return res;
			}
			return this;
		}
		options = options || {};

		const taskSources = options.taskSources || [];
		delete options.taskSources;
		/*if (options.events) {
			eventSources.push(options.events);
			delete options.events;
		}*/
		
		options = $.extend(true, {}, defaults, options);
			
		this.each(function(i, _element) {
			const element = $(_element);
			const tasklist = new TaskList(element, options, taskSources);
			element.data('taskList', tasklist);
			tasklist.render();
		});
		return this;
	};
	
}(jQuery));

function TaskList(element, options, taskSources) {
	this.options = options;
	this.render = renderTaskList;
	const widget = $("<div class='tl-widget'></div>");
	const headerElement = $("<div class='tl-header'></div>");
	const contentElement = $("<div class='tl-container'></div>");
	widget.append(headerElement);
	widget.append(contentElement);
	let newListElement = null;
	let selector;
	let orderSelector;
	element.append(widget);

	// Locals
	let content;

	function renderTaskList() {
		if (!content) initialRender();
	}
	
	function initialRender() {
		createHeader();
		reloadAllLists();
	}
	
	function viewSelected(event)
	{
		reloadAllLists();
	}
	
	function removeNewListForm() {
		if (newListElement != null) {
			newListElement.remove();
			newListElement = null;
		}
	}
	
	function nameInputElement() { return $("<input type='text' class='tl-listNameEdit' maxlength='30' size='30' placeholder='"+options.listNamePlaceholder+"'/>"); }
	
	function addList()
	{
		if (newListElement == null) {
			newListElement = $("<div class='tl-list tl-color0' style='display: none'></div>");
			const formContainer = $("<div class='tl-newlist'></div>");
			const inp = nameInputElement();
			formContainer.append(inp);

			const okButton = $("<button class='button'>" + options.okButton + "</button>");
			const cancelButton = $("<button class='button'>" + options.cancelButton + "</button>");
			const buttRow = $("<div class='tl-buttRow'></div>");
			buttRow.append(cancelButton);
			buttRow.append(okButton);
			buttRow.css('text-align', 'right');
			cancelButton.css('margin-right', '10px');

			const colorInput = $("<input type='hidden' name='swatches' value='0'/>");
			const swatches = generateColorSwatches(colorInput);
			formContainer.append(colorInput);
			formContainer.append(swatches);
			formContainer.append(buttRow);
			
			cancelButton.click(function(evt) {
				newListElement.slideToggle(400, function() {removeNewListForm();});
			});
			
			okButton.click(function(evt) {
				const name = inp.val();
				if (name.length > 0) {
					// add the list
					const data = {};
					data.view = selector.val();
					data.sort = orderSelector.val();
					data.action = 'addList';
					data.name = name;
					data.color = colorInput.val();
					data.position = 'first';
					jQuery.ajax('taskFeed.do', { data: data, type: 'POST' }).done(function(dd) {
						removeNewListForm();
						reloadAllLists();
					})
					.fail(function(data) { removeNewListForm(); console.log('Cannot create list '); });
				}
				else removeNewListForm();
			});
			// resize
			const w = 26 * 13 - 8;
			inp.width(w-4);
			buttRow.width(w);
			
			newListElement.append(formContainer);
			headerElement.after(newListElement);
			newListElement.slideToggle(400, function() {inp.focus();});
		}
	}
	
	function createHeader() {
		headerElement.append("<div class='tl-reminders'>"+options.title+"</div>");

		const grouping = $("<div class='tl-selector'></div>");
		grouping.append("<span class='tl-selectorLabel'>"+options.selectorLabel+":</span>");
		selector = $("<select>" +
			(options.own ? "<option value='5'>"+options.sortManual+"</option>":"")+
			"<option value='0'>"+options.sortPriority+"</option>"+
			"<option value='1'>"+options.sortDate+"</option>"+
			"<option value='2'>"+options.sortType+"</option>"+
			"<option value='4'>"+options.sortCustomer+"</option>"+
			"</select>");
		grouping.append(selector);
		headerElement.append(grouping);
		selector.val(options.view);
		selector.change(viewSelected);

		const sorting = $("<div class='tl-selector'></div>");
		sorting.append("<span class='tl-selectorLabel'>"+options.orderLabel+":</span>");
		orderSelector = $("<select>"+
			"<option value='0'>"+options.orderRecent+"</option>"+
			"<option value='1'>"+options.orderOld+"</option>"+
			"<option value='2'>"+options.orderNew+"</option>"+
			"</select>");
		sorting.append(orderSelector);
		headerElement.append(sorting);
		orderSelector.val(options.sort);
		orderSelector.change(viewSelected);

		const plusElement = $("<div class='tl-plusListButton'></div>");
		const plusLink = $("<a><span class='tl-plusLabel'>" + options.addListAction + "</span></a>");
		plusLink.on("click", addList);
		plusLink.prepend(Icon.fi("plus-circle-14-full", null, "margin-right:4px"))
		plusElement.append(plusLink);
		headerElement.append(plusElement);
	}
	
	function reloadAllLists()
	{
		jQuery.ajax('taskFeed.do?view='+selector.val()+'&sort='+orderSelector.val()+'&action=load').done(function(data) {
			content = data;	// save the data
			renderContent();
		})
		.fail(function(data) {console.log('Cannot load tasks')});
	}
	
	function findListObject(id) {
		for (let i = 0; i < content.lists.length; i++) {
			const listObject = content.lists[i];
			if (listObject.id == id) return listObject;
		}
		return null;
	}
	
	function renderContent() {
		contentElement.empty();	// empty old content
		// Add new content
		if (content) {
			if (content.lists && content.lists.length > 0) {
				for (let i = 0; i < content.lists.length; i++) {
					const listHtml = createListHtml(content.lists[i], content.canReorderLists);
					contentElement.append(listHtml);
				}

				const sops = {
					connectWith: ".tl-items", cursor: "move", handle: ".tl-handle",
					cancel: ".tl-still",
					update: function (event, ui) {
						var listID;
						let currentItems = '';
						if (content.globalListId < 0) { /* virtual list */
							if (ui.sender != null) {
								// Moved to another list
								const itemID = ui.item.attr('id');
								var listID = ui.item.parent().attr('id');
								if (listID.indexOf('listitems') == 0) listID = listID.substring(9);
								const listObject = findListObject(listID);
								if (listObject != null) {
									if (listObject.dragInAction != null && listObject.dragInAction.length > 0) {
										saveDragIn(itemID, listObject, ui.item);
									}
								}
							} else {
								$('.tl-items').each(function () {
									const ids = $(this).sortable('toArray');
									if (ids.length > 0) {
										if (currentItems.length > 0) currentItems += ',';
										currentItems += ids;
									}
								});
								/* currentItems = $('.tl-items').sortable('toArray');*/
								listID = content.globalListId;
								saveListOrder(listID, currentItems);
							}
						} else {
							listID = event.target.id.substring("listitems".length);
							currentItems = $('#listitems' + listID).sortable('toArray');
							saveListOrder(listID, currentItems);
						}
					}
				};
				if (!content.canMoveBetweenLists) delete sops.connectWith;
				$('.tl-items').sortable(sops);
				if (content.canReorderLists) {
					const sops2 = {
						cursor: "move", handle: ".tl-listhandle",
						update: function (event, ui) {
							const listOrder = contentElement.sortable('toArray');
							saveMasterListOrder(listOrder);
						}
					};
					contentElement.sortable(sops2);
				}
				if (content.canAddList) $('.tl-plusListButton').css('visibility','visible');
				else $('.tl-plusListButton').css('visibility','hidden');
				
				resizeItems();
			}
		}
	}
	
	function saveListOrder(listID, itemIDs)
	{
		jQuery.ajax('taskFeed.do?view='+selector.val()+'&sort='+orderSelector.val()+'&action=saveOrder&list='+listID+'&items='+encodeURIComponent(itemIDs)).done(function(data) {
		})
		.fail(function(data) {console.log('Cannot save item order for list '+listID)});
	}
	
	function saveMasterListOrder(listIDs)
	{
		jQuery.ajax('taskFeed.do?view='+selector.val()+'&sort='+orderSelector.val()+'&action=saveMasterOrder&items='+encodeURIComponent(listIDs)).done(function(data) {
		})
		.fail(function(data) {console.log('Cannot save order'); });
	}
	
	function saveDragIn(itemID, listObject, itemDiv) {
		jQuery.ajax('taskFeed.do?view='+selector.val()+'&sort='+orderSelector.val()+'&action=saveDrop&item='+encodeURIComponent(itemID)+"&drop="+encodeURIComponent(listObject.dragInAction)).done(function(data) {
			if (data) {
				if (data.duedateTxt) {
					itemDiv.find(".tl-itemdate").html(data.duedateTxt);
					if (data.due) itemDiv.addClass("tl-due");
					else itemDiv.removeClass("tl-due");
				}
				if (data.priority >= 1 && data.priority <= 5) {
					const priorityContainer = itemDiv.find(".tl-priority");
					priorityContainer.empty();	// remove current icon
					let iconTag = $(Icon.fi("priority-"+data.priority+"{color:var(--priority-"+data.priority+")}"));
					priorityContainer.append(iconTag);
				}
			}
		})
		.fail(function(data) {console.log('Cannot save drop action'); });
	}
	
	function resizeItems() {
		/* var nameWidth = 0;
		var nameSelector = $('.tl-itemname');
		nameSelector.each(function() {
			var theWidth = $(this).width();
			if (theWidth > nameWidth) nameWidth = theWidth;
		});
		if (nameWidth > 0) nameSelector.width(nameWidth);*/
	}
	
	function createAddTaskInput() {
		return $("<input type='text' class='tl-addTask'/>");
	}
	
	function createListHtml(listObject, canReorderLists) {
		const listDiv = $("<div class='tl-list'></div>");
		if (listObject.color) listDiv.addClass('tl-color'+listObject.color)	;
		else listDiv.addClass("tl-color-default");
		listDiv.attr('id', listObject.id);
		const itemsDiv = createListItems(listObject);
		const addItem = listObject.canAdd ? createAddItem(listObject, itemsDiv) : null;
		const listContent = $("<div class='tl-listcontent'></div>");
		const listHeader = createListHeader(listObject, canReorderLists, listContent);
		listDiv.data("listId", listObject.id);
		listDiv.append(listHeader);
		listContent.append(itemsDiv);
		if (addItem != null) listContent.append(addItem);
		listDiv.append(listContent);
		/*var addTask = createAddTaskInput();
		listDiv.append(addTask);*/
		return listDiv;
	}
	
	function generateColorSwatches(valInput)
	{
		const selected = valInput.val();
		const colPal = $("<div class='tl-colpal'></div>");
		colPal.append(valInput);
		for (let i = 0; i <= 12; i++) {
			const cls = 'tl-swatch' + i;
			const sw = $("<div class='tl-swatch " + cls + "'></div>");
			sw.data("swId", i);
			if (i == selected) sw.html("&bull;");
			else sw.html("&nbsp;");
			sw.click(function(evt) {
				$('.tl-swatch').html("&nbsp;");
				const sw = $(this).data("swId");
				valInput.val(sw);
				$(this).html("&bull;");
				const parentList = $(this).parents(".tl-list");
				parentList.removeClass();
				parentList.addClass("tl-list tl-color"+sw);
			});
			colPal.append(sw);
		}
		return colPal;
	}

	let editedList = null;

	function startListEdit(listObject, listNameDiv)
	{
		editedList = new Object();
		editedList.nameDiv = listNameDiv;
		editedList.listObject = listObject;
		listNameDiv.empty();
		editedList.nameInput = nameInputElement();
		if (!listObject.renamable) editedList.nameInput.prop('disabled', true);
		listNameDiv.append(editedList.nameInput);
		editedList.nameInput.val(listObject.name);
		editedList.nameInput.focus();
		editedList.okButton = $("<button class='button'>"+options.okButton+"</button>");
		editedList.cancelButton = $("<button class='button'>"+options.cancelButton+"</button>");
		editedList.deleteButton = $("<button class='button'>"+options.deleteButton+"</button>");
		editedList.okButton.css('float', 'right');
		editedList.okButton.css('margin-left', '10px');
		editedList.cancelButton.css('float', 'right');
		const buttRow = $("<div class='tl-buttRow'></div>");
		if (listObject.deletable) buttRow.append(editedList.deleteButton);
		buttRow.append(editedList.okButton);
		buttRow.append(editedList.cancelButton);

		const listElement = $('#' + listObject.id);
		const savedClasses = listElement.attr("class");
		editedList.cancelButton.click(function(evt) {
			endListEdit(listObject, listNameDiv, false);
			listElement.attr("class", savedClasses);
		});
		
		editedList.okButton.click(function(evt) {
			endListEdit(listObject, listNameDiv, true);
		});
		
		if (listObject.deletable) editedList.deleteButton.click(function(evt) {
			listElement.fadeOut(800, function() {
				endListEdit(listObject, listNameDiv, false);
				deleteList(listObject, listNameDiv);
			});
		});

		const curColor = listObject.color ? listObject.color : 0;
		editedList.colorInput = $("<input type='hidden' name='swatches' value='"+curColor+"'/>");
		const swatches = generateColorSwatches(editedList.colorInput);
		listNameDiv.append(swatches);
		listNameDiv.append(buttRow);
		// resize
		const w = 26 * 13 - 8;
		editedList.nameInput.width(w-4);
		buttRow.width(w);
	}
	
	function endListEdit(listObject, listNameDiv, saveResult)
	{
		if (saveResult) {
			const data = new Object();
			data.view = selector.val();
			data.sort = orderSelector.val();
			data.action = 'saveList';
			data.name = editedList.nameInput.val();
			data.color = editedList.colorInput.val();
			data.id = listObject.id;
			jQuery.ajax('taskFeed.do', { data: data, type: 'POST' }).done(function(dd) {
				listNameDiv.empty();
				listNameDiv.html(data.name);
				listObject.name = data.name;
				listObject.color = data.color;
				editedList = null;
				// set color
				const list = $('#' + listObject.id);
				list.attr('class', 'tl-list');
				list.addClass('tl-color'+listObject.color);
			})
			.fail(function(data) { removeNewListForm(); console.log('Cannot save list '); });
		}
		else {
			listNameDiv.empty();
			listNameDiv.html(listObject.name);
			editedList = null;
		}
	}
	
	function deleteList(listObject, listNameDiv)
	{
		const data = new Object();
		data.view = selector.val();
		data.sort = orderSelector.val();
		data.action = 'deleteList';
		data.id = listObject.id;
		jQuery.ajax('taskFeed.do', { data: data, type: 'POST' }).done(function(dd) {
			reloadAllLists();
		})
		.fail(function(data) { removeNewListForm(); console.log('Cannot delete list '); });
	}
	
	function saveCollapsed(listObject) {
		const data = {};
		data.view = selector.val();
		data.sort = orderSelector.val();
		data.action = 'collapseList';
		data.id = listObject.id;
		data.collapsed = listObject.collapsed;
		jQuery.ajax('taskFeed.do', { data: data, type: 'POST' }).fail(function(data) { console.log('Cannot save list state'); });
	}
	
	function createListHeader(listObject, canReorderLists, listContentDiv) {
		const listHeader = $("<div class='tl-listheader'></div>");
		const openClose = $("<div class='tl-openclose opener left-opener'>" + Icon.fi("triangle-down-14-full") + "</div>");
		const listName = $("<div class='tl-listname'></div>");
		const justName = $("<span></span>");
		listHeader.append(openClose);
		listHeader.append(listName);
		justName.html(listObject.name);
		const editIcon = $(Icon.fi("edit", "tl-edit-icon"));
		listName.append(justName);
		listName.append(editIcon);
		
		if (listObject.collapsed) {
			openClose.addClass("closed");
			listContentDiv.hide();
		}
		if (canReorderLists) {
			const listHandle = $("<div class='tl-listhandle'></div>");
			listHandle.append($(Icon.fi("menu-18")));
			listHeader.append(listHandle);
		}

		openClose.click(function(evt) {
			if (listObject.collapsed) openClose.removeClass("closed");
			else openClose.addClass("closed");
			listObject.collapsed = !listObject.collapsed;

			listContentDiv.slideToggle(400, function() {
				if (!listObject.collapsed) resizeItems();
				saveCollapsed(listObject);
			});
		});
		justName.attr('title', options.editLabel);
		const editHandler = function(evt) {
			if (editedList != null) return;	// another list is edited
			startListEdit(listObject, justName);
		};
		justName.dblclick(editHandler);
		editIcon.click(editHandler);

		return listHeader;
	}
	
	function createAddItemLink(listObject, placeholder, itemsDiv) {
		const addItemLink = $("<a href='#'></a>");
		addItemLink.text(options.addActivityAction);
		addItemLink.prepend(Icon.fi("plus-circle-14-full", null, "font-size:14px;width:22px"));
		addItemLink.click(function(evt) {
			placeholder.empty();
			const addInput = createActivityEditor(listObject, placeholder, itemsDiv);
			placeholder.append(addInput);
			addInput.focus();
			evt.preventDefault();
		});
		return addItemLink;
	}
	
	
	function killActivityEditor(listObject, placeholder, itemsDiv) {
		placeholder.empty();
		placeholder.append(createAddItemLink(listObject, placeholder, itemsDiv));
	}
	
	//['G SERVIS', 'Eurodražby', 'ANNECA', 'Apple', 'Google', 'Facebook', 'Samsung', 'HTC', 'Tovek', 'Microsoft', 'Waterman']
	function createActivityEditor(listObject, placeholder, itemsDiv) {
		const editor = $("<input type='text' class='tl-addinput' name='additem'/>");
		editor.keydown(function(e) {
			if (e.keyCode == 13 && $(this).val().length > 0) {
				const data = new Object();
				data.view = selector.val();
				data.sort = orderSelector.val();
				data.action = 'addActivity';
				data.name = editor.val();
				data.list = listObject.id;
				data.createAction = (listObject.createAction == null ? "" : listObject.createAction);
				jQuery.ajax('taskFeed.do', { data: data, type: 'POST' }).done(function(data) {
					itemsDiv.append(createItem(data));
					resizeItems();	// correct widths
					editor.val("");
				})
				.fail(function(data) { removeNewListForm(); console.log('Cannot add activity '); });
				e.preventDefault();
			}
			else if (e.keyCode == 9 && $(this).val().length > 0) {
				//console.log("Přidat vazbu");
				e.preventDefault();
			}
			else if (e.keyCode == 27 /* ESC */) {
				killActivityEditor(listObject, placeholder, itemsDiv);
				e.preventDefault();
			}
		});
		editor.blur(function(e) { killActivityEditor(listObject, placeholder, itemsDiv); });
		/*editor.autocomplete({
			source: function(request, response) {
				var	sepos = request.term.indexOf(';');
				if (sepos > 0) {
					response( $.ui.autocomplete.filter(
							['G SERVIS', 'Eurodražby', 'ANNECA', 'Apple', 'Google', 'Facebook', 'Samsung', 'HTC', 'Tovek', 'Microsoft', 'Waterman'],
							request.term.substring(sepos+1)) );
				}
			},
			minLength: 0
		});*/
		return editor;
	}
	
	function saveComplete(item) {
		const data = {};
		data.view = selector.val();
		data.sort = orderSelector.val();
		data.action = 'saveComplete';
		data.id = item.id;
		data.completed = item.completed;
		jQuery.ajax('taskFeed.do', { data: data, type: 'POST' }).done(function(data) {
		})
		.fail(function(data) { console.log('Cannot save item state'); });
	}
	
	function createItem(item) {
		const itemDiv = $("<div class='tl-listitem'></div>");
		if (item.due) itemDiv.addClass("tl-due");
		itemDiv.attr('id', item.id);
		if (!item.canMove) itemDiv.addClass('tl-still');

		const tlIcon = $("<a href='" + item.url + "' class='tl-icon'></a>");
		itemDiv.append(tlIcon);
		if (item.icon != null) {
			let iconTag = $(Icon.fi(item.icon));
			tlIcon.append(iconTag);
		}

		const doneChbx = $("<input type='checkbox' class='task-check' style='top:0'/>");
		if (item.completed) doneChbx.attr('checked', 'true');
		if (!item.canComplete) doneChbx.attr('disabled', 'true');
		itemDiv.append(doneChbx);
		
		doneChbx.change(function() {
			const v = $(this).prop('checked');
			item.completed = v;
			saveComplete(item);
		});

		const tlPriority = $("<span class='tl-priority'></span>");
		itemDiv.append(tlPriority);
		if (item.priority >= 1 && item.priority <= 5) {
			let iconTag = $(Icon.fi("priority-"+item.priority+"{color:var(--priority-"+item.priority+")}"));
			tlPriority.append(iconTag);
		}

		const dateText = $("<div class='tl-itemdate'></div>");
		if (item.duedate) dateText.html(item.duedateTxt);
		
		const itemName = $("<div class='tl-itemname'></div>");
		const nameLink = $("<a href='" + item.url + "'></a>");
		nameLink.text(item.name);
		itemName.append(nameLink);
		itemDiv.append(itemName);
		initPreviewFor(nameLink);

		itemDiv.append(dateText);
		if (item.bindName) {
			const bindName = $("<div class='tl-itembind'></div>");
			const bindLink = $("<a href='" + item.bindUrl + "'></a>");
			bindLink.text(item.bindName);
			bindName.append(bindLink);
			itemDiv.append(bindName);
			initPreviewFor(bindLink);
		}
		const handle = $("<span class='tl-item-handle tl-handle'></span>");
		handle.append($(Icon.fi("menu-14")));
		itemDiv.append(handle);

		if (item.description) {
			const desc = $("<div class='tl-desc no-blocks'></div>");
			desc.html(item.description);
			itemDiv.append(desc);
		}
		return itemDiv;
	}
	
	function createListItems(listObject)
	{
		const itemsDiv = $("<div class='tl-items'></div>");
		itemsDiv.attr('id', "listitems"+listObject.id);
		if (listObject.items && listObject.items.length > 0) {
			for (let i = 0; i < listObject.items.length; i++) {
				const item = listObject.items[i];
				itemsDiv.append(createItem(item));
			}
		}
		return itemsDiv;
	}
	
	function createAddItem(listObject, itemsDiv) {
		const addItem = $("<div class='tl-additem'></div>");
		addItem.append(createAddItemLink(listObject, addItem, itemsDiv));
		return addItem;
	}
}